import discord from "../assets/discord.svg";
import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import css from "../assets/css.png";
import flutter from "../assets/flutter.png";
import git from "../assets/git.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";
import unity from "../assets/unity-big.png";
import intellij from "../assets/intellij.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

export default {
  email,
  mobile,
  api,
  css,
  flutter,
  git,
  html,
  javascript,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  unity,
  intellij,
  discord,
};
